<script setup lang="ts">
import { getAreas } from '@/javascripts/utils/inquiry_form_options';
import Inquiry from '@/javascripts/utils/inquiry';
import SlideIndicator from './slide_indicator.vue';

const emit = defineEmits(['next']);

const props = defineProps<{
  inquiry: Inquiry,
  currentSlideIndex: number,
}>();

const areas = getAreas();

const emitNextIfUnchanged = function(clicked: number | string) {
  if (props.inquiry.areaCd == clicked) {
    emit('next');
  }
}
</script>

<template>
  <div class="inner_content inner_step">
    <div class="main_content step_content">
      <SlideIndicator :current-slide-index="currentSlideIndex" />
      <h2>あなたのお住まいのエリアは？</h2>
      <div class="box_step_btn box_step_btn_p01">
        <div
          v-for="area in areas"
          :key="area.cd"
          class="step_btn"
        >
          <label :for="`area_cd_${area.cd}`">
            <input
              :id="`area_cd_${area.cd}`"
              v-model="inquiry.areaCd"
              type="radio"
              name="area_cd"
              :value="area.cd"
              @change="emit('next')"
              @click="emitNextIfUnchanged(area.cd)"
            >
            <p>{{ area.text }}</p>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
